import { Link } from 'react-router-dom';

export default function StrategicSupportPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-gradient-to-br from-purple-600 to-blue-600 text-white py-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <Link 
            to="/"
            className="inline-flex items-center gap-2 text-white/90 hover:text-white mb-8 transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            Back to home
          </Link>
          
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center">
              <i className="ri-compass-3-line text-3xl"></i>
            </div>
            <h1 className="text-5xl font-bold">Strategic Support</h1>
          </div>
          
          <p className="text-xl text-white/90 leading-relaxed">
            Align commercial efforts with market realities through expert guidance and insights.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 lg:px-8 py-16">
        <div className="prose prose-lg max-w-none">
          <h2 className="text-3xl font-bold text-slate-900 mb-6">What is Strategic Support?</h2>
          <p className="text-slate-600 leading-relaxed mb-8">
            Our Strategic Support service provides expert guidance to help you align your commercial efforts with market realities. We work closely with your team to develop and execute strategies that drive sustainable growth. From market entry planning to competitive positioning, our experienced consultants bring deep industry knowledge and proven methodologies to help you achieve your business objectives.
          </p>

          <h2 className="text-3xl font-bold text-slate-900 mb-6">Key Features</h2>
          <div className="space-y-6 mb-12">
            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-lightbulb-line text-xl text-blue-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">Strategic Planning</h3>
                <p className="text-slate-600 leading-relaxed">
                  Develop comprehensive strategies that align with your business goals, market opportunities, and competitive landscape.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-map-pin-line text-xl text-blue-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">Market Entry Strategy</h3>
                <p className="text-slate-600 leading-relaxed">
                  Navigate new markets with confidence through detailed entry strategies, risk assessments, and go-to-market plans.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-user-star-line text-xl text-blue-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">Expert Consultation</h3>
                <p className="text-slate-600 leading-relaxed">
                  Access experienced consultants who provide personalized guidance, best practices, and strategic recommendations.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-rocket-line text-xl text-blue-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">Growth Acceleration</h3>
                <p className="text-slate-600 leading-relaxed">
                  Identify and capitalize on growth opportunities through data-driven insights and proven growth strategies.
                </p>
              </div>
            </div>
          </div>

          <h2 className="text-3xl font-bold text-slate-900 mb-6">Benefits</h2>
          <ul className="space-y-3 mb-12">
            <li className="flex items-start gap-3">
              <i className="ri-check-line text-xl text-blue-600 mt-1"></i>
              <span className="text-slate-600">Align your strategy with market realities and opportunities</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="ri-check-line text-xl text-blue-600 mt-1"></i>
              <span className="text-slate-600">Accelerate decision-making with expert guidance</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="ri-check-line text-xl text-blue-600 mt-1"></i>
              <span className="text-slate-600">Reduce strategic risks through proven methodologies</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="ri-check-line text-xl text-blue-600 mt-1"></i>
              <span className="text-slate-600">Optimize resource allocation for maximum impact</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="ri-check-line text-xl text-blue-600 mt-1"></i>
              <span className="text-slate-600">Build sustainable competitive advantages</span>
            </li>
          </ul>

          <div className="bg-slate-50 rounded-2xl p-8 mt-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Ready to Get Started?</h2>
            <p className="text-slate-600 mb-6">
              Partner with our strategic experts to transform your business vision into reality.
            </p>
            <Link 
              to="/"
              onClick={(e) => {
                e.preventDefault();
                window.REACT_APP_NAVIGATE('/');
                setTimeout(() => {
                  const element = document.getElementById('contact');
                  if (element) {
                    const offset = 80;
                    const elementPosition = element.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - offset;
                    window.scrollTo({
                      top: offsetPosition,
                      behavior: 'smooth'
                    });
                  }
                }, 100);
              }}
              className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Contact Us
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
